<button
  class="flex items-center gap-4 text-left"
  (click)="onDownload()"
  [disabled]="download.loading()"
>
  @if (download.loading()) {
    <mat-spinner diameter="16" />
  } @else {
    <mat-icon svgIcon="cp-download" class="!w-4 !h-4 flex-shrink-0"></mat-icon>
  }
  <span class="font-bold text-base text-cp-primary-100 underline">{{ doc().name }}</span>
</button>
